// extracted by mini-css-extract-plugin
module.exports = {"item":"_5D2q_Gq2","icon":"_5D2Hf9Go","name-container":"_5D1jK6TJ","name-link":"_5D2lG0ao","name-link__label":"_5D1W5pD4","description":"_5D2JRl8D","flags":"_5D3VgCmy"};